module.exports = __webpack_public_path__ + "static/flags/SI-3b017b5b3721c4a1473886a6540a6a50.gif";